module.exports = __webpack_public_path__ + "static/media/instapage2.6d3039f3.png";